define('page/partner-application', [
    'jquery', 'common/calendar', 'log', 'jquery.cookie'
], ($, SchedulePlugin, log) => {
    const $video = document.querySelector('#video-service-h5');
    const $videoPlay = $('#js-play');
    const $popupMask = $('.popup-mask');
    const $popupSuccess = $('.popup-success');
    const $popupWrap = $('.popup-wrap');
    const $codeImg = $('.js-codeimg');
    const $imgBox = $('.js-codeimg .img');
    const $closeIcon = $('.close-icon');
    const $closeSuccess = $('.js-success-close');
    const $submitBtn = $('.js-submit-btn');
    const $toast = $('.alert');

    /* 合伙人信息收集 */
    const $partnerAdd = $('.js-partner-add');
    const $partnerAddClose = $('.js-partner-add-close');
    // 姓名输入框
    const $nameInput = $('.js-input-name');
    // 填写详细地址
    const $addrInput = $('.js-input-address');
    // 计划开业地区
    const $provinceControl = $('.js-select-province');
    const $cityControl = $('.js-select-city');
    // 最快加盟时间
    const $scheduleControl = $('.js-select-calendar');
    // 是否从事过汽车相关行业
    const $carJobControl = $('.js-select-industry');
    // 是否拥有汽车相关店铺
    const $carShopControl = $('.js-select-shop');
    // 了解人人车合伙人加盟渠道
    const $joinKnownControl = $('.js-select-channel');
    // 介绍人信息
    const $introducerInfoItem = $('.js-introducer-info');
    const $introducerInput = $('.js-input-intro');
    // 备注
    const $markInput = $('.js-input-remark');
    // 补充信息提交成功弹窗
    const $infoAddSuccess = $('.js-partner-add-success');
    // 提交补充信息
    const $infoAddSubmit = $('.js-add-submit');
    // 返回首页
    const $returnBtn = $('.js-return-btn');
    // 判断是否是徐州专题页
    const isXzPartner = !!$('.partner-xz').length;

    let reqCity = false;
    // 记录手机号 token
    let userInfo = {};
    const reqUrl = __DEVELOPMENT__ ? 'https://arktest.renrenche.com' : 'https://ark.renrenche.com';

    // 省份信息分类
    const provinceConfig = {
        A: [
            { data: '澳门', redirect: 'not' },
            { data: '安徽', redirect: '' }
        ],
        B: [
            { data: '北京', redirect: 'not' }
        ],
        C: [
            { data: '重庆', redirect: 'not' }
        ],
        F: [
            { data: '福建', redirect: '' }
        ],
        G: [
            { data: '甘肃', redirect: '' },
            { data: '贵州', redirect: '' },
            { data: '广东', redirect: '' },
            { data: '广西', redirect: '' }
        ],
        H: [
            { data: '海南', redirect: '' },
            { data: '河北', redirect: '' },
            { data: '河南', redirect: '' },
            { data: '湖北', redirect: '' },
            { data: '湖南', redirect: '' },
            { data: '黑龙江', redirect: '' }
        ],
        J: [
            { data: '吉林', redirect: '' },
            { data: '江苏', redirect: '' },
            { data: '江西', redirect: '' }
        ],
        L: [
            { data: '辽宁', redirect: '' }
        ],
        N: [
            { data: '宁夏', redirect: '' },
            { data: '内蒙古', redirect: '' }
        ],
        Q: [
            { data: '青海', redirect: '' }
        ],
        S: [
            { data: '上海', redirect: 'not' },
            { data: '四川', redirect: '' },
            { data: '山东', redirect: '' },
            { data: '山西', redirect: '' },
            { data: '陕西', redirect: '' }
        ],
        T: [
            { data: '天津', redirect: 'not' }
        ],
        X: [
            { data: '新疆', redirect: '' },
            { data: '西藏', redirect: '' },
            { data: '香港', redirect: 'not' }
        ],
        Z: [
            { data: '浙江', redirect: '' }
        ]
    };

    // 代入登录手机号
    const initPhone = () => {
        // 登录手机号
        const loginPhone = $.cookie('rrc_intent_phone') || $.cookie('rrc_login_phone') || '';
        $('.partner-input').val(loginPhone);
    };

    const showPopup = () => {
        $('.code-input').val('');
        $popupMask.show();
        $popupWrap.show();
    };

    const hidePopup = () => {
        $popupMask.hide();
        $popupWrap.hide();
    };

    let timer;
    const showToast = (text, delay = 1500) => {
        $toast.html(text).show();
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            $toast.hide();
        }, delay);
    };

    const hideToast = () => {
        if (timer) {
            clearTimeout(timer);
            $toast.html('').hide();
        }
    };

    const partnerSubmit = ({
        phone,
        code
    }, cb) => {
        $.ajax({
            type: 'POST',
            url: `${reqUrl}/intent/ark/v1/intent/partner/add`,
            xhrFields: {
                withCredentials: true
            },
            data: {
                city: RRC.cityName,
                verify_code: code,
                phone,
                source: isXzPartner ? 'hehuoren_website1_xuzhou' : 'hehuoren_website1',
                submit_source: isXzPartner ? '合伙人招商页1-立即报名-底部悬浮-徐州' : '合伙人招商页1-立即报名-底部悬浮',
                intent_type: 'rrc-openapi-partner',
                device: 'PC',
                uuid: $.cookie('new_visitor_uuid') || '',
                origin: ''
            },
            success(res) {
                const { status, errmsg } = res;
                if (status === 0) {
                    userInfo = {
                        phone: res.data.phone,
                        token: res.data.token
                    };
                    cb && cb(); // eslint-disable-line
                } else if (status === 200) {
                    const { image, status_v2 } = res.msg;
                    $imgBox.attr('src', image);
                    showPopup();
                    if (status_v2 && status_v2 === '401') {
                        showToast('验证码错误');
                    }
                    $codeImg.off('click');
                    $codeImg.on('click', () => {
                        partnerSubmit({
                            phone,
                            code: ''
                        });
                    });
                } else if (status === 301) {
                    hidePopup();
                    showToast(errmsg, 5000);
                } else {
                    hidePopup();
                    showToast(errmsg);
                }
            },
            error() {
                showToast('请稍后再试');
            }
        });
    };

    // 收起所有下拉框
    function foldAllOptions() {
        const selectWrap = $('.select-wrap');
        selectWrap.removeClass('spread');
        selectWrap.addClass('folder');
    }

    // 自定义下拉框option状态处理
    function optionHandler($target, delay = 0) {
        $target = $target.parent();
        if ($target.hasClass('folder')) {
            foldAllOptions();
            $target.removeClass('folder');
            if (delay) {
                setTimeout(() => {
                    $target.addClass('spread');
                }, delay);
            } else {
                $target.addClass('spread');
            }
        } else {
            $target.removeClass('spread');
            $target.addClass('folder');
        }
    }

    // 自定义下拉框选择结果处理
    function selectHandle($target, text, type) {
        $target.addClass('completed');
        $target.text(text);
        $(`.check-error.${type}`).hide();
    }

    // 自定义下拉框点击事件
    function optionsClick($target) {
        const text = $target.text();
        const type = $target.parent().data('type');
        const isLog = $target.parent().data('log');
        const logCh = $target.parent().data('ch');
        const isBool = $target.data('bool');
        const fr = $target.data('fr');
        const textBox = $(`.js-select-${type}`).find('.text');
        if (isBool !== '') {
            textBox.data('select', isBool);
        }
        if (type === 'province') {
            $cityControl.find('.text').text('请选择城市');
        }
        if (fr && fr === 'introducer') {
            $introducerInfoItem.show();
        }
        if (fr && fr === 'other') {
            $introducerInfoItem.hide();
        }
        // 用于初次选择该选项上报埋点
        if (!isLog && logCh) {
            log.push(['_trackEvent', 'copartner-detailpage_information_input', 'submit', '', '', { value: logCh }]);
            $target.parent().data('log', true);
        }
        selectHandle(textBox, text, type);
        optionHandler($(`.js-select-${type}`));
    }

    // 日历控件初始化
    function initSchedule() {
        const mySchedule = new SchedulePlugin({ // eslint-disable-line
            el: '.js-option-calendar',
            clickCb: (y, m, d) => {
                const selectTime = `${y}-${m}-${d}`;
                const target = $scheduleControl.find('.text');
                const isLog = $scheduleControl.data('log');
                const logCh = $scheduleControl.data('ch');
                // 用于初次选择时间上报埋点
                if (!isLog) {
                    log.push(['_trackEvent', 'copartner-detailpage_information_input', 'submit', '', '', { value: logCh }]);
                    $scheduleControl.data('log', true);
                }
                selectHandle(target, selectTime, 'join');
                optionHandler($scheduleControl);
            },
            upDate: `${new Date().getFullYear() + 1}, 11`,
            noPrevDate: true
        });
    }

    // 通过省拿到城市
    function getCityByProvince(province_name, cb) {
        if (!province_name) {
            return false;
        }
        reqCity = true;
        $.getJSON(`/index.php?c=citylist&m=get_city_by_province&d=api&province=${encodeURIComponent(province_name)}`, result => { // eslint-disable-line
            if (result.status === 0 && result.cities) {
                cb && cb(result.cities); // eslint-disable-line
            }
        });
    }

    // 城市下拉框初始化
    function initCityOpt(list) {
        if (!list) return;
        if (Object.prototype.toString.call(list) !== '[object Array]') {
            list = [...list];
        }
        const cityBox = $('.js-option-city');
        let cHtmlStr = '';
        list.forEach((elt) => {
            cHtmlStr += `<li class="item">${elt}</li>`;
        });
        cityBox.html(cHtmlStr);

        // 绑定事件
        cityBox.find('.item').on('click', function () {
            optionsClick($(this));
        });
    }

    // 省份下拉框初始化
    function initProviceOpt() {
        const provinceBox = $('.js-option-province');
        const pHtmlArr = [];
        let pHtmlStr = '';
        pHtmlArr.push('<header class="option-title">请选择</header>');
        Object.keys(provinceConfig).forEach((elt) => {
            pHtmlStr += `<h3 class="letter">${elt}</h3>
                         <ul class="provice-list js-option" data-type="province">`;
            provinceConfig[elt].forEach((item) => {
                pHtmlStr += `<li class="item" data-name="${item.data}" data-redirect="${item.redirect}">${item.data}</li>`;
            });
            pHtmlStr += '</ul>';
        });
        pHtmlArr.push(pHtmlStr);
        provinceBox.html(pHtmlArr.join(''));
        provinceBox.find('.item').on('click', function () {
            const provinceName = $(this).data('name');
            if ($(this).data('redirect') === '') {
                getCityByProvince(provinceName, initCityOpt);
            } else {
                initCityOpt(provinceName, true);
                reqCity = true;
            }
        });
    }

    // 必填项辅助方法
    function checkUtil({ attr, type, err, def, reg, regErr }) {
        let isComplete;
        const $errBox = $(`.check-error.${type}`);
        if (attr === def) {
            $errBox.text(err).show();
            isComplete = false;
        } else if (reg && !reg.test(attr)) {
            $errBox.text(regErr).show();
            isComplete = false;
        } else {
            $errBox.hide();
            isComplete = true;
        }
        return isComplete;
    }

    // 补充信息表单信息收集及验证
    function addFormCheck() {
        const result = {};
        // 检查输入姓名
        const name = $nameInput.val();
        // 计划开业地区：省份
        const province = $provinceControl.find('.text').text();
        // 计划开业地区：城市
        const city = $cityControl.find('.text').text();
        // 最快加盟时间
        const join = $scheduleControl.find('.text').text();
        /* 选填项目 */
        // 填写详细地址
        const address = $addrInput.val();
        // 是否从事过汽车相关行业
        const industry = $carJobControl.find('.text').data('select');
        // 是否拥有汽车相关店铺
        const shop = $carShopControl.find('.text').data('select');
        // 了解人人车合伙人加盟渠道
        const channel = $joinKnownControl.find('.text').text();
        // 介绍人信息
        const recom_info = $introducerInput.val();
        // 备注
        const remark = $markInput.val();

        // 必填项
        const checkAttr = [{
            type: 'name',
            attr: name,
            err: '请输入姓名',
            bool: false,
            def: '',
            reg: /^[^0-9]{1,5}$/,
            regErr: '请输入正确的姓名(1-5个字符，不包含数字)'
        }, {
            type: 'province',
            attr: province,
            err: '请选择省份',
            bool: false,
            def: '请选择省份'
        }, {
            type: 'city',
            attr: city,
            err: '请选择城市',
            bool: false,
            def: '请选择城市'
        }, {
            type: 'join',
            attr: join,
            err: '请选择最快加盟时间',
            bool: false,
            def: '请选择最快加盟时间'
        }];

        checkAttr.forEach((elt) => {
            elt.bool = checkUtil(elt);
            if (elt.bool) {
                result[elt.type] = elt.attr;
            }
        });

        // 非必填项
        const selectAttr = [{
            type: 'address',
            attr: address,
            def: '',
            reg: /^.{1,30}$/,
            regErr: '字数不应超过30字',
            bool: true
        }, {
            type: 'industry',
            attr: industry,
            def: '',
            bool: true
        }, {
            type: 'shop',
            attr: shop,
            def: '',
            bool: true
        }, {
            type: 'channel',
            attr: channel,
            def: '请选择',
            bool: true
        }, {
            type: 'recom_info',
            attr: recom_info,
            def: '',
            reg: /^.{1,20}$/,
            regErr: '字数不应超过20字',
            bool: true
        }, {
            type: 'remark',
            attr: remark,
            def: '',
            reg: /^.{1,300}$/,
            regErr: '字数不应超过300字',
            bool: true
        }];

        selectAttr.forEach((item) => {
            if (item.attr !== item.def) {
                if (item.reg && !item.reg.test(item.attr)) {
                    item.bool = false;
                    $(`.check-error.${item.type}`).text(item.regErr).show();
                } else {
                    result[item.type] = item.attr;
                }
            }
        });
        return checkAttr.every(elt => elt.bool) && selectAttr.every(elt => elt.bool) && result;
    }

    // 表单重置
    function resetForm() {
        const clearInput = [$nameInput, $addrInput, $introducerInput, $markInput];
        clearInput.forEach((elt) => {
            elt.val('');
            elt.data('log', false);
        });

        const resetSelect = [
            {
                ele: $provinceControl,
                text: '请选择省份'
            },
            {
                ele: $cityControl,
                text: '请选择城市'
            },
            {
                ele: $scheduleControl,
                text: '请选择最快加盟时间'
            },
            {
                ele: $carJobControl,
                text: '请选择'
            },
            {
                ele: $carShopControl,
                text: '请选择'
            },
            {
                ele: $joinKnownControl,
                text: '请选择'
            }
        ];

        resetSelect.forEach((item) => {
            item.ele.find('.text').text(item.text);
            item.ele.find('.text').removeClass('completed');
            item.ele.find('.text').data('select', '');

            $('.js-option').data('log', false);
            $('.js-select-calendar').data('log', false);
        });
        $('.js-option-city').html('');
        reqCity = false;
        $('.check-error').text('').hide();
        $introducerInfoItem.hide();
    }

    // 提交表单
    function addInfoSubmit(opt, cb) {
        Object.assign(opt, userInfo, {
            intent_type: 'rrc-openapi-partner',
            device: '',
            origin: ''
        });
        $.ajax({
            type: 'POST',
            url: `${reqUrl}/intent/ark/v1/intent/partner/extra`,
            data: opt,
            success(res) {
                const { status, errmsg } = res;
                if (status === 0) {
                    cb && cb(); // eslint-disable-line
                    log.push(['_trackEvent', 'copartner-detailpage_information-result_popup', 'submit', '', '', { value: '成功' }]);
                } else if (status === 200) {
                    const { image, status_v2 } = res.msg;
                    $imgBox.attr('src', image);
                    showPopup();
                    if (status_v2 && status_v2 === '401') {
                        showToast('验证码错误');
                    }
                    $codeImg.off('click');
                    $codeImg.on('click', () => {
                        addInfoSubmit(opt);
                    });
                } else {
                    hidePopup();
                    showToast(errmsg);
                    log.push(['_trackEvent', 'copartner-detailpage_information-result_popup', 'submit', '', '', { value: '失败' }]);
                }
            },
            error() {
                showToast('请稍后再试');
                log.push(['_trackEvent', 'copartner-detailpage_information-result_popup', 'submit', '', '', { value: '失败' }]);
            }
        });
    }

    // 补充信息弹窗高度控制
    function addHeightHandle() {
        const wrapHeight = window.innerHeight;
        if (wrapHeight <= 790) {
            $partnerAdd.css('height', `${wrapHeight * 0.95}px`);
        } else {
            $partnerAdd.css('height', 'auto');
        }
    }

    // 事件绑定
    function bindBtn() {
        $('body').bind('login', () => {
            initPhone();
        });

        $(window).resize(() => {
            addHeightHandle();
        });

        $closeIcon.click(() => {
            $('.code-input').val('');
            $popupMask.hide();
            $popupWrap.hide();
        });

        $closeSuccess.click(() => {
            $popupMask.hide();
            $popupSuccess.hide();
        });

        $videoPlay.click(() => {
            $video.play();
            $videoPlay.hide();
        });

        $('.partner-input').on('input', () => {
            hideToast();
        });

        $submitBtn.on('click', function () {
            const phone = $('.partner-input').val();
            const code = $('.code-input').val();
            const phoneReg = /^1[0-9]{10}$/;
            if (!phone) {
                showToast('请输入手机号');
            } else if (!phoneReg.test(phone)) {
                showToast('请输入正确的手机号');
            } else {
                const param = {
                    phone,
                    code: code || ''
                };
                partnerSubmit(param, () => {
                    $('.code-input').val('');
                    $popupWrap.hide();
                    // $popupSuccess.show();
                    addHeightHandle();
                    $popupMask.show();
                    $partnerAdd.show();
                    log.push(['_trackEvent', '合伙人招商补充信息页', 'rrc-pageModule-show']);
                });
                const event = isXzPartner ? 'copartnerpage_phone-submit-xuzhou_click' : 'copartnerpage_phone-submit_click';
                log.push(['_trackEvent', event, 'click']);
            }
        });

        /* 合伙人信息收集 */
        $('.js-input').focus(() => {
            foldAllOptions();
        });

        $('.js-input').on('input', function () {
            // 用于输入框内容改变上报埋点
            let isLog = $(this).data('log');
            const logCh = $(this).data('ch');
            if (!isLog && logCh) {
                log.push(['_trackEvent', 'copartner-detailpage_information_input', 'submit', '', '', { value: logCh }]);
                isLog = $(this).data('log', true);
            }
        });

        $('.js-input').on('input', function () {
            const type = $(this).data('field');
            $(`.check-error.${type}`).text('').hide();
        });

        $('.js-select').click(function () {
            if ($(this).hasClass('js-select-city')) {
                reqCity? optionHandler($(this), 100) : showToast('请先选择省份'); // eslint-disable-line
            } else {
                optionHandler($(this));
            }
        });
        $('.js-option .item').on('click', function () {
            optionsClick($(this));
        });

        // 合伙人信息关闭
        $partnerAddClose.click(function () {
            $partnerAdd.hide();
            $popupMask.hide();
            resetForm();
        });
        // 合伙人信息提交
        $infoAddSubmit.click(function () {
            const checkRes = addFormCheck();
            if (checkRes) {
                addInfoSubmit(checkRes, () => {
                    $partnerAdd.hide();
                    $infoAddSuccess.show();
                    resetForm();
                });
                log.push(['_trackEvent', 'copartner-detailpage_information-submit_click', 'click']);
            }
        });
        // 返回合伙人首页
        $returnBtn.click(function () {
            $infoAddSuccess.hide();
            $popupMask.hide();
        });
    }

    function init() {
        initPhone();
        initSchedule();
        initProviceOpt();
        bindBtn();
    }
    return {
        init
    };
});
/* istanbul ignore if */
if (typeof window.__karma__ === 'undefined') {
    require(['page/partner-application'], (page) => {
        page.init();
    });
}
